module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('home-footer-text', {
    attrs: {
      "title": "用户帮助",
      "link1": "如何注册成为买家或卖家？",
      "link2": "如何查好货源？",
      "link3": "如何发布会货源？",
      "link4": "如何发布会求购？"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('home-footer-text', {
    attrs: {
      "title": "常见问题",
      "link1": "如何安装木材码头APP",
      "link2": "线上交易流程",
      "link3": "为什么要做信息认证？",
      "link4": "服务站是什么？"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2afb63a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeFooterLeft.vue
// module id = 145
// module chunks = 1